/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Lunes", "Martes", "Mi\xE9rcoles", "Jueves", "Viernes", "S\xE1bado", "Domingo"], a = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"], o = "A\xF1os", r = "A\xF1o", s = "Mes", t = "Semana", n = "D\xEDa", d = "Hoy", y = "No hay evento", M = "Todo el d\xEDa", l = "Borrar", m = "Crear un evento", v = "dddd D MMMM YYYY", i = { weekDays: e, months: a, years: "A\xF1os", year: "A\xF1o", month: "Mes", week: "Semana", day: "D\xEDa", today: "Hoy", noEvent: "No hay evento", allDay: "Todo el d\xEDa", deleteEvent: "Borrar", createEvent: "Crear un evento", dateFormat: "dddd D MMMM YYYY" };
export {
  M as allDay,
  m as createEvent,
  v as dateFormat,
  n as day,
  i as default,
  l as deleteEvent,
  s as month,
  a as months,
  y as noEvent,
  d as today,
  t as week,
  e as weekDays,
  r as year,
  o as years
};
